export default "__VITE_ASSET__e0ab9b76__"